import type { BaseKeyFunction } from "../../../lib";

export const keyMe: BaseKeyFunction = () => ["me"];
export const keyEmailPreferences: BaseKeyFunction = () => [
  "me",
  "email-preferences",
];
